import initialState from 'state/initialState';

import ajaxCartReducer from './ajax-cart';
import appReducer from './app';
import catalogReducer from './catalog';
import collectionReducer from './collection';
import collectionPageReducer from './collection-page';
import storeLocationReducer from './contentful';
import cookieConsentReducer from './cookie-consent';
import experimentsReducer from './experiments';
import geofencingReducer from './geofencing';
import mailingReducer from './mailing';
import pdpReducer from './pdp';
import personalizationsReducer from './personalizations';
import shopReducer from './shop';
import topNavigationReducer from './top-navigation';
import upsellsReducer from './upsells';

const reducer = (state = initialState, action) => ({
  ajaxCart: ajaxCartReducer(state.ajaxCart, action),
  collection: collectionReducer(state.collection, action),
  upsells: upsellsReducer(state.upsells, action),
  pdp: pdpReducer(state.pdp, action),
  app: appReducer(state.app, action),
  mailing: mailingReducer(state.mailing, action),
  experiments: experimentsReducer(state.experiments, action),
  personalizations: personalizationsReducer(state.personalizations, action),
  geofencing: geofencingReducer(state.geofencing, action),
  topNavigation: topNavigationReducer(state.topNavigation, action),
  catalog: catalogReducer(state.catalog, action),
  collectionPage: collectionPageReducer(state.collectionPage, action),
  cookieConsent: cookieConsentReducer(state.cookieConsent, action),
  shop: shopReducer(state.shop, action),
  storeLocation: storeLocationReducer(state.storeLocation, action),
});

export default reducer;
